import { AppDate } from '../envTypes';

import { ModelBase } from './base';
import { BasicProfile } from './profile';
import { PopStoreExtendedSubscriptionLevel } from './creator-subscription';

export enum PollType {
  // Results displayed instantly
  Public = 'public',
  // Results displayed after poll closes
  Blind = 'blind',
}

export enum PollStatus {
  Active = 'active',
  Suspended = 'suspended',
  Ended = 'ended',
}

// stores/{storeId}/polls/{autoId}
export interface Poll extends ModelBase {
  slug: string;

  type: PollType;
  title: string;
  description?: string;

  // Enable configurable end dates (default: 24 hours).
  dueAt: AppDate;
  endedAt?: AppDate;

  // specify how many options can be selected by user.
  // this is not updatable once the poll is created as it will
  // affect how `PollVoter.unifiedId` works
  isMultiChoice: boolean;

  // allow unauthenticated users to vote?
  isAnonymousVotingAllowed: boolean;

  // specify if the poll responses should be locked after voting,
  // user cannot change their resopnses if this is set to true.
  shouldLockResponse: boolean;

  status: PollStatus;

  deleted: boolean;
  deletedAt?: AppDate;

  voteCount: number;
  voterCount: number;
}

// stores/{storeId}/polls/{autoId}/options/{autoId}
export interface PollOption extends ModelBase {
  title: string;
  sort: number;
  hidden: boolean;
  voteCount: number;
  voterCount: number;
}

// stores/{storeId}/polls/{autoId}/votes/{autoId}
export interface PollVote extends ModelBase {
  optionId: string;
  profile?: BasicProfile;
  /**
   *  used for deduplication.
   *  - if user is authenticated, unifiedId would be `user:${userId}`
   *  - if user is unauthenticated, unifiedId would be `device:${deviceId}`
   *  - if poll allows multiple answers, add a postfix `${optionId}` to the above unifiedId
   */
  unifiedId: string;
  userId?: string;
  deviceId?: string;
  timeZone: string;
  ip: string;
  userAgent: string;
  age: number; // 0 indicates unknown
  subscriptionLevel?: PopStoreExtendedSubscriptionLevel | 'none';
}
